<div class="p-6 max-w-4xl mx-auto">
    <div class="flex items-center justify-between mb-6">
        <div>
            <h1 class="text-xl font-semibold text-slate-900">Sincronización pendiente</h1>
            <p class="text-sm text-slate-500 mt-1">
                Cambios guardados sin conexión, a la espera de sincronizarse con el servidor.
            </p>
        </div>
        <button type="button" (click)="retryAll()"
            class="px-4 py-2 rounded-md bg-slate-900 text-white text-sm font-medium hover:bg-slate-800 transition-all"
            [disabled]="!online()">
            Reintentar todo
        </button>
    </div>

    @if (!online()) {
        <div class="mb-4 rounded-md border border-amber-200 bg-amber-50 px-4 py-2.5 text-sm text-amber-800">
            Sin conexión ahora mismo - se reintentará automáticamente en cuanto vuelva internet.
        </div>
    }

    @if (loading()) {
        <p class="text-sm text-slate-500">Cargando…</p>
    } @else if (entries().length === 0) {
        <div class="rounded-xl border border-slate-200 bg-white p-8 text-center text-sm text-slate-500">
            No hay cambios pendientes de sincronizar.
        </div>
    } @else {
        <div class="rounded-xl border border-slate-200 bg-white overflow-hidden">
            <table class="w-full text-sm">
                <thead class="bg-slate-50 text-slate-500 text-xs uppercase tracking-wide">
                    <tr>
                        <th class="text-left px-4 py-2.5 font-medium">Tipo</th>
                        <th class="text-left px-4 py-2.5 font-medium">Acción</th>
                        <th class="text-left px-4 py-2.5 font-medium">Estado</th>
                        <th class="text-left px-4 py-2.5 font-medium">Detalle</th>
                        <th class="text-right px-4 py-2.5 font-medium">Opciones</th>
                    </tr>
                </thead>
                <tbody class="divide-y divide-slate-100">
                    @for (entry of entries(); track entry.id) {
                        <tr>
                            <td class="px-4 py-3 text-slate-800">{{ describeEntry(entry) }}</td>
                            <td class="px-4 py-3 text-slate-600">{{ actionLabels[entry.method] }}</td>
                            <td class="px-4 py-3">
                                <span
                                    class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium"
                                    [class.bg-slate-100]="entry.status === 'pending'"
                                    [class.text-slate-600]="entry.status === 'pending'"
                                    [class.bg-blue-100]="entry.status === 'syncing'"
                                    [class.text-blue-700]="entry.status === 'syncing'"
                                    [class.bg-green-100]="entry.status === 'synced'"
                                    [class.text-green-700]="entry.status === 'synced'"
                                    [class.bg-red-100]="entry.status === 'failed'"
                                    [class.text-red-700]="entry.status === 'failed'">
                                    {{ statusLabels[entry.status] }}
                                </span>
                            </td>
                            <td class="px-4 py-3 text-slate-500 max-w-xs truncate" [title]="entry.lastError ?? ''">
                                {{ entry.status === 'failed' ? entry.lastError : '' }}
                            </td>
                            <td class="px-4 py-3 text-right space-x-2">
                                @if (entry.status === 'failed') {
                                    <button type="button" (click)="retry(entry)"
                                        class="text-xs font-medium text-slate-700 hover:text-slate-900 underline">
                                        Reintentar
                                    </button>
                                    <button type="button" (click)="discard(entry)"
                                        class="text-xs font-medium text-red-600 hover:text-red-800 underline">
                                        Descartar
                                    </button>
                                }
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    }
</div>
